var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDongphiWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "21px",
    viewBox: "0 0 23 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-dongphi-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage-Final",
    transform: "translate(-132.000000, -265.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(23.000000, 252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(86.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(10.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-dongphi-white",
    transform: "translate(13.571429, 13.571429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,2.5 C22,1.11909091 20.8715833,3.10055012e-14 19.4791667,3.10055012e-14 L6.1875,3.10055012e-14 C4.79508333,3.10055012e-14 3.66666667,1.11909091 3.66666667,2.5 L3.66666667,2.72727273 L22,2.72727273 L22,2.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66666667,3.63636364 L3.66666667,5.45454545 L15.8125,5.45454545 C18.2141667,5.45454545 20.1666667,7.39090909 20.1666667,9.77272727 L20.1666667,12.6363636 C21.23,12.3363636 22,11.3727273 22,10.2272727 L22,3.63636364 L3.66666667,3.63636364 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8125,7.27272727 L2.52083333,7.27272727 C1.13025,7.27272727 0,8.39363636 0,9.77272727 L0,17.5 C0,18.8790909 1.13025,20 2.52083333,20 L15.8125,20 C17.2030833,20 18.3333333,18.8790909 18.3333333,17.5 L18.3333333,9.77272727 C18.3333333,8.39363636 17.2030833,7.27272727 15.8125,7.27272727 Z M2.52083333,11.1363636 C2.52083333,10.1336364 3.34308333,9.31818182 4.35416667,9.31818182 L5.72916667,9.31818182 C6.74025,9.31818182 7.5625,10.1336364 7.5625,11.1363636 L7.5625,12.5 C7.5625,13.5027273 6.74025,14.3181818 5.72916667,14.3181818 L4.35416667,14.3181818 C3.34308333,14.3181818 2.52083333,13.5027273 2.52083333,12.5 L2.52083333,11.1363636 Z M14.8958333,17.9545455 L3.4375,17.9545455 C2.9315,17.9545455 2.52083333,17.5472727 2.52083333,17.0454545 C2.52083333,16.5436364 2.9315,16.1363636 3.4375,16.1363636 L14.8958333,16.1363636 C15.4018333,16.1363636 15.8125,16.5436364 15.8125,17.0454545 C15.8125,17.5472727 15.4018333,17.9545455 14.8958333,17.9545455 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDongphiWhite);
export default __webpack_public_path__ + "static/media/ic-dongphi-white.8b2c9acd5c79aee7afec330d5560e4a4.svg";
export { ForwardRef as ReactComponent };